const DIGITS = /^[0-9]+$/;

export const COMMAND_LIMITS = {
  ping: {
    param: 'count',
    label: 'Quantidade (1-100)',
    min: 1,
    max: 100,
    defaultValue: '4',
    message: 'Quantidade deve ser um número inteiro de 1 a 100.',
  },
  traceroute: {
    param: 'maxHops',
    label: 'Máximo de saltos (1-30)',
    min: 1,
    max: 30,
    defaultValue: '30',
    message: 'Máximo de saltos deve ser um número inteiro de 1 a 30.',
  },
};

export const isValidLimit = (rawValue, limit) => {
  if (typeof rawValue !== 'string' || !DIGITS.test(rawValue)) return false;
  const value = Number(rawValue);
  return value >= limit.min && value <= limit.max;
};

export const buildCommandRequest = ({ command, ip, value }) => {
  const limit = COMMAND_LIMITS[command];
  if (!isValidLimit(value, limit)) return { error: limit.message };
  return {
    query: `command=${encodeURIComponent(command)}&ip=${encodeURIComponent(ip)}&${limit.param}=${Number(value)}`,
  };
};
